// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallQuotationPricingType {
    LumpSum = "O",
    TimeMaterial = "N",
    LumpSumPlus = "M",
}

export let nameof = "ServiceCallQuotationPricingType";
